import {observer} from "mobx-react";
import {GlobalMessageStore} from "../../stores/GlobalMessageStore";
import {Alert, Snackbar} from "@mui/material";
import {useEffect} from "react";
import {useStore} from "../../stores/Store";

export default observer(function GlobalMessage(){
    const { GlobalMessageStore } = useStore()
    const { isOpen, message, color, setIsOpen } = GlobalMessageStore

    return (
        <Snackbar
            open={isOpen}
            autoHideDuration={5000}
            onClose={() => setIsOpen(false)}
            anchorOrigin={{horizontal: 'right', vertical: 'top'}}
        >
            <Alert
                onClose={() => setIsOpen(false)}
                severity={color}
                variant={'filled'}
                sx={{width: '100%'}}
            >
                { message }
            </Alert>
        </Snackbar>

    )
})